module.exports = __webpack_public_path__ + "img/01.ae1c4afd.jpg";